import { analytics } from "./api";
import { logEvent } from 'firebase/analytics';


/**
 * funcion  que envia un evento a google analytics
 * @param {string} eventName nombre del evento
 * @param {object} eventParams parametros del evento
 * @returns {boolean} retorna verdadero si envio el evento
 */
export const sendEvent = async (eventName, eventParams) => {
    try {
        await logEvent(analytics, eventName, eventParams);
        return true;
    } catch (error) {
        console.error(error);
        return false;
    }
}


/**
 * funcion que envia un evento de registro de usuario a google analytics
 * @param {string} userId id del usuario
 * @returns {boolean} retorna verdadero si envio el evento
 */


export const sendRegisterEvent = async (userId) => {
    try {
        await logEvent(analytics, "register", { userId: userId });
        return true;
    } catch (error) {
        console.error(error);
        return false;
    }
}

/**
 * funcion que envia un evento de inicio de sesion a google analytics
 * @param {string} userId id del usuario
 * @returns {boolean} retorna verdadero si envio el evento
 */
export const sendLoginEvent = async (userId) => {
    try {
        await logEvent(analytics, "login", { userId: userId });
        return true;
    } catch (error) {
        console.error(error);
        return false;
    }
}

/**
 * funcion que envia un evento de cierre de sesion a google analytics
 * @param {string} userId id del usuario
 * @returns {boolean} retorna verdadero si envio el evento
 */
export const sendLogoutEvent = async (userId) => {
    try {
        await logEvent(analytics, "logout", { userId: userId });
        return true;
    } catch (error) {
        console.error(error);
        return false;
    }
}

/**
 * funcion que envia un evento de observacion de mascotas a google analytics
 * @param {string} userId id del usuario
 * @param {string} petId id de la mascota
 * @returns {boolean} retorna verdadero si envio el evento
 */

export const sendWatchPetEvent = async (userId, petId) => {
    try {
        await logEvent(analytics, "watch_pet", { userId: userId, petId: petId });
        return true;
    } catch (error) {
        console.error(error);
        return false;
    }
}


/**
 * funcion que envia un evento de observacion de foro a google analytics
 * @param {string} forumId id del foro
 * @returns {boolean} retorna verdadero si envio el evento
 */
export const sendWatchForumEvent = async (forumId) => {
    try {
        await logEvent(analytics, "watch_forum", { forumId: forumId });
        return true;
    } catch (error) {
        console.error(error);
        return false;
    }
}

/**
 * funcion que envia un evento de creacion de foro a google analytics
 * @param {string} userId id del usuario
 * @returns {boolean} retorna verdadero si envio el evento
 */
export const sendCreateForumEvent = async (userId) => {
    try {
        await logEvent(analytics, "create_forum", { userId: userId});
        return true;
    } catch (error) {
        console.error(error);
        return false;
    }
}